import React, {lazy, Suspense} from 'react'

const PrayerMethodLazy = lazy(() => import('./PrayerMethod'))

const PrayerMethod = props => (
    <Suspense fallback={null}>
        <PrayerMethodLazy {...props}/>
    </Suspense>
)

export default PrayerMethod
